// filepath: c:\Users\gcodron\work\front3\app\components\ToolsBar\ProcessingListButton.tsx
import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import './ProcessingListButton.scss';
import { Button, DropdownItem, Icon } from 'semantic-ui-react';
import preventDefault from 'app/utils/preventDefault';

type ProcessingListItemProps = React.ComponentProps<typeof DropdownItem> & {
  onEditClick?: () => void;
  isEditEnabled?: boolean;
};

const ProcessingListItem = memo(
  ({ onEditClick, isEditEnabled, text, children, ...props }: ProcessingListItemProps) => {
    const intl = useIntl();
    const onEdit = useCallback(
      (e: React.MouseEvent) => {
        preventDefault(e);
        return onEditClick();
      },
      [onEditClick]
    );
    return (
      <DropdownItem {...props}>
        {children || text}
        {onEditClick && isEditEnabled && (
          <button
            onClick={onEdit}
            className="picoxia edit-processing-button"
            aria-label={intl.formatMessage({ id: 'general.edit' })}
          >
            <Icon name="pencil" />
          </button>
        )}
      </DropdownItem>
    );
  }
);

export default ProcessingListItem;
